export const INTERVAL_TIME = 4000;

export const TRANSLATION_KEYS = [
  "loading_wait",
  "please_wait",
  "hang_wait",
  "almost_there",
];
